var _circle, _circle2, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfographic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5028_55667)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.3334,
    r: 20,
    fill: "url(#paint0_linear_5028_55667)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5028_55667",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.3334,
    r: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5028_55667)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4999 38.3333C17.4999 24.7333 4.83323 21.6667 -0.000100613 21.8333C-4.83343 22 3.4999 51.8334 3.4999 51.8334C17.1666 53 41.4999 51.9333 29.4999 38.3333Z",
    fill: "#6BA5DF",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.7173 72.4931C-70.4282 34.3969 -41.302 40.5783 -26.2912 31.4709C-9.26287 21.1401 1.68613 20.2654 10.3965 23.7006C11.732 24.2274 13.0153 24.8564 14.2594 25.5668M140.303 88.3333C101.419 34.198 81.4195 57.1005 60.3571 54.4779C54.608 53.7622 49.7283 52.1141 45.4299 49.92M45.4299 49.92C42.7052 49.8109 35.8564 50.4722 30.2601 53.9856M45.4299 49.92C44.1159 49.2488 42.8557 48.5269 41.6423 47.7643M41.6423 47.7643C32.9442 46.8281 24.9726 51.6272 11.3895 54.4771M41.6423 47.7643C40.3429 46.9479 39.0965 46.0863 37.8923 45.1916M37.8923 45.1916C30.84 44.4574 19.947 49.92 8.29839 52.5219M37.8923 45.1916C37.0068 44.5342 36.1444 43.8584 35.3011 43.1703M-1.59005 53.9856C21.9199 48.5392 27.8065 42.2341 35.3004 43.1703C34.3081 42.3616 33.3428 41.5352 32.3974 40.7012M-2.60684 53.4726C15.5588 48.007 20.2964 40.7012 32.3982 40.7012C32.0388 40.384 31.6824 40.0669 31.3292 39.7474M31.3292 39.7474C14.2056 38.5524 13.4715 46.8957 -6.73317 53.4719M31.3292 39.7474C30.6956 39.1768 30.0705 38.6039 29.4507 38.0317M29.4507 38.0317C11.3895 35.3208 6.30472 48.7281 -13.6879 54.4771M29.4507 38.0317C28.7181 37.3552 27.9946 36.6793 27.275 36.0089M27.275 36.0089C-2.60761 36.0089 6.82541 43.1703 -13.6879 49.92C-26.047 53.9856 -33.9463 44.7646 -54.2178 53.4726M27.275 36.0089C26.3711 35.1657 25.4757 34.3316 24.581 33.5145M-59.6097 54.4771C-46.9343 42.0966 -25.6054 53.4726 -11.2873 44.237C8.36136 31.5631 17.5348 33.2212 24.5818 33.5145C23.9413 32.9301 23.3015 32.3541 22.6595 31.7896M22.6595 31.7896C22.6595 31.7896 2.7805 27.1388 -18.7996 42.6772C-30.9735 51.4437 -50.1921 42.0698 -62.8636 53.9856M22.6595 31.7896C21.7763 31.014 20.8901 30.2614 19.9931 29.541M19.9931 29.541C19.9931 29.541 2.26135 23.2075 -20.6581 39.7474C-32.4319 48.2443 -55.7161 42.0698 -67.8194 53.9856M19.9931 29.541C19.2029 28.9059 18.4042 28.2961 17.594 27.7163M17.594 27.7163C17.594 27.7163 2.73595 22.5717 -13.6879 33.2726C-38.7516 49.602 -53.6487 38.9794 -74.5092 55.1245M17.594 27.7163C16.508 26.9399 15.3998 26.218 14.2594 25.5668M14.2594 25.5668C14.2594 25.5668 -1.59005 19.6887 -19.9362 34.0713C-32.5909 43.9912 -57.5877 39.0439 -74.8963 53.9856M10.3965 23.7013C-11.288 20.1433 -20.6581 34.837 -55.7161 42.0705C-67.1221 46.0909 -73.5869 48.6474 -77.6541 54.4779",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.7173 68.7206C-60.3969 24.3778 -46.8268 39.1398 -26.2912 27.6993C24.4842 -0.588262 21.1205 47.321 60.0921 52.1746C81.1546 54.798 102.956 35.1886 140.303 84.5609",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.5581 65.6283C-59.2377 21.2855 -45.4649 36.4046 -25.132 24.607C24.7733 -4.34947 23.0377 44.7947 62.0093 49.6483C83.0717 52.271 104.89 33.6438 143.773 87.779",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.5581 62.9412C-54.8157 19.1944 -45.2068 33.4234 -24.874 21.6258C25.0313 -7.33071 23.6774 41.9801 62.649 46.833C83.7115 49.4556 104.89 30.9559 143.773 85.0911",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.5581 60.3821C-52.7683 17.0192 -46.0347 30.7921 -25.3854 18.8109C24.5198 -10.1456 24.7011 39.037 63.6727 43.8906C84.7352 46.514 104.891 28.3975 143.774 82.5336",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.6807 56.4294C-59.8057 19.4499 -45.9054 28.2325 -25.2576 16.2513C23.425 -11.9955 25.0854 36.2217 64.057 41.0753C85.1195 43.6979 104.89 26.2219 143.773 80.3572",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99 53.0787C-61.9813 18.8071 -45.9061 25.1022 -25.2576 13.1218C23.4251 -15.1251 25.0854 33.0922 64.057 37.945C85.1195 40.5684 110.163 24.9978 149.047 79.133",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99 48.4999C-64.5971 16.4516 -48.8674 26.1926 -25.7475 11.35C21.6173 -19.0564 25.0854 30.0824 64.057 34.9352C85.1195 37.5586 110.163 21.9879 149.047 76.1232",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99 44.9687C-64.5971 12.9203 -48.8674 22.6613 -25.7475 7.81869C21.6173 -22.5877 25.5393 28.0802 64.5109 32.9338C85.5734 35.5572 108.855 20.1147 149.047 72.5919",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.25 40.7251C-61.8471 8.67681 -51.9356 22.0388 -25.7477 5.22706C19.8032 -24.0151 25.02 27.7709 63.9917 32.6245C80.8717 34.7273 85.5564 19.1765 101.921 32.6245C118.286 46.0725 161.53 47.0448 161.53 47.0448",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.25 37.8574C-61.8471 5.80988 -51.4871 18.9607 -25.2984 2.14894C20.2525 -27.0932 25.5845 25.6029 64.5561 30.4557C81.4362 32.5584 85.809 15.8542 103.577 30.4557C121.345 45.0572 161.53 44.1763 161.53 44.1763",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.25 35.3986C-61.8471 3.35031 -51.4871 16.5019 -25.2984 -0.310627C20.2525 -29.5528 25.8195 23.1364 64.7911 27.9892C81.6712 30.0919 85.2438 17.1262 99.9106 25.5225C114.577 33.9188 140.376 39.8314 160.401 37.3854",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.0869 29.5534C-59.684 -2.49414 -53.6615 15.3643 -27.4728 -1.44739C18.078 -30.6895 27.2 20.8569 66.1716 25.7105C83.0517 27.8132 85.245 16.3589 99.9118 24.7551C114.579 33.1514 141.2 37.5081 161.225 35.0621",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 26.6089C-58.5687 -5.43947 -52.5463 12.419 -26.3576 -4.39272C19.1933 -33.6349 27.4973 18.5904 66.4682 23.444C83.3483 25.546 86.2489 15.0478 100.916 23.444C115.582 31.8403 142.314 34.5628 162.34 32.1168",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 24.2751C-58.5687 -7.77249 -54.2497 7.07629 -26.3576 -6.72574C29.1255 -34.1816 27.975 14.7637 66.9466 19.6173C83.8267 21.7193 87.3655 13.932 102.032 22.3283C116.698 30.7245 142.314 32.2297 162.34 29.7837",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 17.6253C-58.5687 -14.4231 -53.954 1.00785 -26.3576 -13.3763C30.5862 -43.057 26.6334 10.543 65.6703 14.8329C80.1827 16.428 87.983 8.36044 104.583 17.8634C121.183 27.3663 142.313 25.58 162.339 23.134",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 12.43C-58.5687 -19.6183 -55.4661 -7.5634 -26.3576 -18.5715C37.1247 -42.5792 26.6334 5.34779 65.6703 9.63769C80.1827 11.2328 87.983 3.1652 104.583 12.6681C121.183 22.171 142.313 20.3847 162.339 17.9387",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 8.07451C-58.5687 -23.9738 -55.4661 -11.9182 -26.3576 -22.9271C37.1247 -46.9347 26.6334 0.992254 65.6703 5.28216C80.1827 6.87724 87.983 -1.19033 104.583 8.31259C121.183 17.8155 142.313 16.0292 162.339 13.5832",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9717 3.64434C-58.5687 -28.404 -55.4661 -16.3483 -26.3576 -27.3572C37.1247 -51.3649 26.6334 -3.43792 65.6703 0.851982C80.1827 2.44706 87.983 -5.62127 104.583 3.88241C121.183 13.3853 142.313 11.599 162.339 9.15302",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.4946 -1.15547C-57.0917 -33.2038 -53.9891 -21.1481 -24.8805 -32.1571C38.6017 -56.1647 28.1104 -8.23773 67.1481 -3.94782C81.6605 -2.35274 89.46 -10.4203 106.061 -0.917395C122.661 8.58552 143.792 6.79921 163.818 4.35321",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90.3862 -5.96849C-55.9841 -38.0161 -52.8807 -25.9612 -23.7722 -36.9693C39.7101 -60.9769 29.2188 -13.05 68.2565 -8.76008C82.7689 -7.165 90.5684 -15.2326 107.169 -5.72965C123.769 3.77326 144.9 1.98695 164.925 -0.459046",
    stroke: "white",
    strokeWidth: 0.8
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.6666L16.3125 26.6666L11 21.2121",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5028_55667",
    x1: 8.42086,
    y1: 6.43191,
    x2: 30.5686,
    y2: 33.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "#3068BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5028_55667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographic);
export default __webpack_public_path__ + "static/media/Infographic.9e9868c962454e3c379c898a6afcec30.svg";
export { ForwardRef as ReactComponent };